/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @ngdoc service
 * @name NetworkSecurityPolicyDos
 * @description
 *     An item of a Network Security Policy DoS rule containing blocked addresses.
 */
angular.module('aviApp').factory('NetworkSecurityPolicyDos', ['Item', Item => {
    const NetworkSecurityPolicyDos = class extends Item {
        /** @override */
        getIdFromData_(data) {
            return data && data.name || '';
        }
    };

    Object.assign(NetworkSecurityPolicyDos.prototype, {
        objectName: 'NetworkSecurityPolicyDos',
    });

    return NetworkSecurityPolicyDos;
}]);
